import api from "../../utils/api";
import { Endpoint, getEndpointURL } from "../common/endpoints";
// One or more endpoints have a request body as a union type (oneOf). The package to
// generate types (quicktype) doesn't cleanly create the union types when using
// --explicit-union. Package is also outdated and updating is currently
// unfeasible as it requires node v18.12.0. Current solution is to get the
// union request body types from the top level 'Api' interface generated
export const requiredActionList = async (body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.RequiredActionList), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const requiredActionSelf = async (requiredActionId, body, _queryParams, headers) => {
    return api.API.get(getEndpointURL(Endpoint.RequiredActionSelf, { requiredActionId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const requiredActionAttachDocument = async (requiredActionId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.RequiredActionAttachDocument, { requiredActionId }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const requiredActionCheckDocument = async (requiredActionId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.RequiredActionCheckDocument, { requiredActionId }), {
        credentials: "include",
        headers,
        json: { data: body },
    }).json();
};
export const requiredActionConfirmDeposit = async (requiredActionId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.RequiredActionConfirmDeposit, { requiredActionId }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
export const requiredActionSubmitAchDetails = async (requiredActionId, body, _queryParams, headers) => {
    return api.API.post(getEndpointURL(Endpoint.RequiredActionSubmitAchDetails, {
        requiredActionId,
    }), {
        credentials: "include",
        headers,
        json: {
            data: body,
        },
    }).json();
};
